// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"4ef59470","787":"4dc135a2","858":"b971a78a"}[chunkId] + ".chunk.js";
};